<template>
  <div
    v-if="item.goodsCode || preview || searchContext"
    class="goods-item goods-card"
    :role="searchContext ? 'button' : undefined"
    :tabindex="searchContext ? 0 : undefined"
    @keydown.enter="searchContext && openDetail()"
    @keydown.space.prevent="searchContext && openDetail()"
    @click="openDetail"
  >
    <div class="left">
      <!-- :style="{backgroundImage:'url('+item.goodsImage+')'}"-->
      <!-- 商品图片 -->
      <img
        :src="imageSrc"
        :alt="item.goodsName || $t('marketComponents.productImage')"
        @error="handleImageError"
      />
      <!-- 精选 -->
      <div v-if="item.goodsType === 1 || item.type == 1" class="type sell">
        {{ $t("marketComponents.featured") }}
      </div>
      <!-- 求 -->
      <div v-if="item.goodsType === 2 || item.type == 2" class="type buy">
        {{ $t("marketComponents.buy") }}
      </div>
    </div>
    <div class="right">
      <div class="right_name">
        <!--产品标题 -->
        <span>
          {{ showPartNumber ? (item.goodsNum || "--") : (item.goodsName || item.title) }}
        </span>
        <!-- 料号 -->
        <!-- <span class="" v-if="!item.goodsModel">{{ item.goodsModel }}</span> -->
      </div>
      <!-- 标签 -->
      <!-- 这里需要一个品牌名称  goodsBrand -->
      <!-- <div class="tags" v-if="item.labels && item.labels.length > 0">
        <span
          v-for="(items, indexs) in JSON.parse(item.labels)"
          :key="indexs"
          >{{ items }}</span
        >
      </div> -->
      <div class="goods-meta">
        <div v-if="searchContext" class="right_price">
          <span class="price search-price">{{ searchPriceParts.amountText || $t("searchResults.noPrice") }}<span v-if="searchPriceParts.unitText" class="font12"> {{ searchPriceParts.unitText }}</span></span>
        </div>
        <div class="right_price" v-else-if="item.priceUnit == 0 || item.priceUnit == 10">
          <!-- 10:美元  0:人民币 -->
          <span class="price"
            >{{ $formatPrice(item.salePrice) }}
            <span class="font12">{{ priceSymbol }}</span>
          </span>
          <!--        <span class="old">¥{{ item.linePriceMax }}</span>-->
        </div>
        <!-- <span class="count">
          余{{ item.quantity ?? 0 }}{{ item.goodsUnit ?? "个" }}
        </span> -->
        <div class="person" v-if="item.shopContacts && !publisherChat">
          <img class="x" :src="item.shopContactsImage || require('@/img/prodetail/x.png')" alt="" />
          <span class="font12">{{ item.shopContacts }}</span>
        </div>
      </div>
      <div v-if="publisherChat" class="publisher-chat-row">
        <PublisherChatAvatar :name="item.shopContacts" :avatar="item.shopContactsImage" :user-id="item.shopContactsId" :available="Boolean(item.goodsCode && item.shopContacts)" @chat="$emit('publisher-chat', item)" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { createSearchImageFallback } from "@/utils/searchImageFallback";
import PublisherChatAvatar from '@/components/chat-workbench/PublisherChatAvatar.vue';

export default {
  name: "GoodsItem",
  components: { PublisherChatAvatar },
  props: {
    publisherChat: Boolean,
    showPartNumber: { type: Boolean, default: false },
    searchContext: Boolean,
    preview: Boolean,
    fallbackImage: { type: String, default: "" },
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      imageFailed: false,
      defaultImage: require("@/assets/default-goods.png"),
    };
  },
  computed: {
    searchPriceParts() {
      return this.item.searchDisplay?.priceParts || { amountText: this.item.searchDisplay?.priceText || "", unitText: "" };
    },
    imageFallback() {
      return this.searchContext
        ? createSearchImageFallback(this.item.searchDisplay || this.item)
        : this.fallbackImage || this.defaultImage;
    },
    imageSrc() {
      return (!this.imageFailed && this.item.goodsImage) || this.imageFallback;
    },
    ...mapState({
      priceUnitCNY: (state) => state.price.priceUnitCNY,
      priceUnitUSD: (state) => state.price.priceUnitUSD,
    }),
    // 获取价格单位符号
    priceSymbol() {
      if (!this.item.priceUnit && this.item.priceUnit !== 0) return "";
      const usdUnit = this.priceUnitUSD;
      const cnyUnit = this.priceUnitCNY;

      // 如果没有配置，使用默认值
      if (!usdUnit || !cnyUnit) {
        return this.item.priceUnit === 10 ? "$" : "¥";
      }

      const usdValue = Number(usdUnit.value != null ? usdUnit.value : 10);
      // 根据priceUnit值返回对应的符号（优先使用remark，如果没有则使用name的第一个字符）
      if (this.item.priceUnit === usdValue) {
        return `${usdUnit.name}${usdUnit.remark}` || usdUnit.name?.charAt(0) || "$";
      } else {
        return `${cnyUnit.name}${cnyUnit.remark}` || cnyUnit.name?.charAt(0) || "¥";
      }
    },
  },
  watch: {
    "item.goodsImage"() {
      this.imageFailed = false;
    },
  },
  methods: {
    openDetail() {
      if (this.preview) {
        this.$emit("preview-click");
        return;
      }
      if (!this.item.goodsCode) return;
      const path = `/prodetail/${encodeURIComponent(this.item.goodsCode)}`;
      this.$router.push(
        this.searchContext ? `${path}?backUrl=${encodeURIComponent(this.$route.fullPath)}` : path
      );
    },
    handleImageError(e) {
      this.imageFailed = true;
      // 避免无限循环（如果默认图也加载失败）
      const fallback = this.imageFallback;
      if (e.target.getAttribute("src") !== fallback) {
        e.target.src = fallback;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.goods-item.goods-card {
  .publisher-chat-row { display: flex; justify-content: flex-end; }
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  margin: 0;
  overflow: hidden;
  padding: 8px;
  background: #ffffff;
  border: 1px solid #e9edf3;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(30, 56, 96, 0.04);
  cursor: pointer;
  transition: transform 0.16s ease, box-shadow 0.16s ease;

  &:active {
    box-shadow: 0 1px 6px rgba(30, 56, 96, 0.08);
    transform: scale(0.985);
  }

  .left {
    position: relative;
    width: 100%;
    aspect-ratio: 1 / 1;
    overflow: hidden;
    background: #f3f5f8;
    border-radius: 9px;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .type {
      position: absolute;
      top: 6px;
      left: 6px;
      width: auto;
      min-width: 30px;
      height: 20px;
      padding: 0 7px;
      color: #fff;
      font-size: 10px;
      font-weight: 600;
      line-height: 20px;
      text-align: center;
      border-radius: 6px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    }

    .sell {
      background: linear-gradient(135deg, #4b91ff, #357ae8);
    }

    .buy {
      background: linear-gradient(135deg, #ff6961, #e84338);
    }
  }

  .right {
    position: relative;
    display: block;
    flex: none;
    padding: 7px 2px 0;
    gap: 0;

    .right_name {
      display: block;
      min-width: 0;
      overflow: hidden;
      color: #252b33;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .goods-meta {
      display: flex;
      width: 100%;
      align-items: center;
      flex-wrap: wrap;
      gap: 4px 6px;
      margin-top: 5px;
    }

    .right_price {
      max-width: 100%;
      flex: 0 0 auto;
      overflow: hidden;
      white-space: nowrap;
    }

    .price {
      display: block;
      overflow: hidden;
      margin-right: 2px;
      color: #4286f5;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .count {
      white-space: nowrap;
    }

    .tags {
      span {
        display: inline-block;
        padding: 2px 5px;
        margin-right: 5px;
        margin-bottom: 2px;
        background: #eee;
        border-radius: 5px;
      }
    }

    .person {
      display: flex;
      max-width: 100%;
      flex: 0 0 auto;
      align-items: center;
      gap: 4px;
      margin-left: auto;
      overflow: hidden;
      color: #667085;
      white-space: nowrap;

      .x {
        width: 16px;
        height: 16px;
        flex: 0 0 16px;
        object-fit: cover;
        border-radius: 50%;
      }

      span {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .goods-item.goods-card {
    transition: none;
  }
}
</style>
